import {
  COMPENSATION_SUMMARY_MENU_ROLE_IDS,
  ERP_LEAVE_IMPORT_ROLE_IDS,
  RoleID,
  OVERLOAD_MEMO_ADMIN_ROLE_IDS,
  OVERLOAD_MEMO_REVIEW_ROLE_IDS,
  OVERLOAD_MEMO_ROLE_IDS,
  SCHEDULE_CORRECTION_REQUEST_REVIEW_ROLE_IDS,
  SUBJECT_MANAGEMENT_EDIT_ROLE_IDS,
  SUBJECT_MANAGEMENT_ROLE_IDS,
  SUBJECT_SCHEDULE_REVIEW_ROLE_IDS,
  SUBJECT_SCHEDULE_ROLE_IDS,
  TEACH_COMPENSATION_MANAGEMENT_ROLE_IDS,
  TEACH_COMPENSATION_ROLE_IDS,
  TEACH_COMPENSATION_REPORT_ROLE_IDS,
  TEACH_COMPENSATION_REVIEW_ROLE_IDS,
  DISBURSEMENT_APPROVE_TITLE_ROLE_IDS,
  DISBURSEMENT_CERTIFY_TITLE_ROLE_IDS,
  DISBURSEMENT_COVER_MEMO_VIEW_ROLE_IDS,
  DISBURSEMENT_DOCUMENT_VIEW_ROLE_IDS,
  DISBURSEMENT_MANAGEMENT_ROLE_IDS,
} from "src/utils/enum/role.enum";
import { CoreMenuItem } from "./core-menu";

export const SUBJECT_MASTER_DATA_STANDALONE_ROLE_IDS = SUBJECT_MANAGEMENT_EDIT_ROLE_IDS
  .filter((roleId) => roleId !== RoleID.ADMIN);

export const SYSTEM_NAVIGATION_MENU: CoreMenuItem[] = [
  {
    title: "Dashboard Summary",
    url: "/compensation-summary-dashboard",
    icon: "chart-simple",
    type: "item",
    role: COMPENSATION_SUMMARY_MENU_ROLE_IDS,
    featureFlag: "enableCompensationSummary",
    classes: "settings-menu-group",
  },
  {
    title: "การตั้งค่า",
    icon: "setting-2",
    type: "accordion",
    role: [RoleID.ADMIN],

    classes: "settings-menu-group",
    children: [
      {
        title: "ช่วงเวลาการศึกษา",
        icon: "",
        url: "/settings/study-period",
        type: "item",
      },
      {
        title: "วันหยุดราชการ",
        icon: "",
        url: "/settings/pubblic-holiday",
        type: "item",
      },
      {
        title: "สาขาวิชา",
        icon: "",
        url: "/settings/departments",
        type: "item",
      }, {
        title: "หลักสูตร",
        icon: "",
        url: "/settings/curriculum-types",
        type: "item",
      }, {
        title: "ผู้ใช้งาน",
        icon: "",
        url: "/settings/users-management",
        type: "item",
      },
      {
        title: "ตั้งค่าอัตราเบิกจ่าย",
        icon: "",
        url: "/settings/compensation-rates",
        type: "item",
        role: [RoleID.ADMIN],
      },
      {
        // v1.3 ADR-6/10/12 — per-term วันที่ส่งเบิก + per-dept แผนงาน/การเงิน — context/decisions/DECISION_DisbursementV13.md
        title: "ตั้งค่าการส่งเบิก",
        icon: "",
        url: "/settings/disbursement-plan",
        type: "item",
        role: [RoleID.ADMIN],
        featureFlag: "enableDisbursement",
      },
      {
        // Admin sees รายวิชา nested here (inherits the accordion's [ADMIN] gate).
        // Officer/Head can't see this admin-only accordion — they get the
        // standalone item below instead.
        title: "รายวิชา",
        icon: "",
        url: "/settings/subject",
        type: "item",
      },
    ],
  },

  {
    // Standalone master-data entry for the non-admin master-data roles
    // (academic_officer + head_of_education). Admin is intentionally excluded
    // here to avoid a duplicate — admin sees รายวิชา under การตั้งค่า above.
    title: "รายวิชา",
    url: "/settings/subject",
    icon: "book",
    type: "item",
    role: SUBJECT_MASTER_DATA_STANDALONE_ROLE_IDS,
    classes: "settings-menu-group",
  },
  {
    title: "MENU.SUBJECT_MANAGEMRNT",
    url: "/subject-management",
    icon: "notepad",
    type: "item",
    role: SUBJECT_MANAGEMENT_ROLE_IDS,
    classes: "settings-menu-group",
  },
  {
    title: "การจัดการตารางสอน",
    url: "/schedule-submissions-management",
    icon: "calendar",
    type: "accordion",
    role: SUBJECT_SCHEDULE_ROLE_IDS,
    classes: "settings-menu-group",
    children: [
      {
        title: "ตารางสอน",
        icon: "",
        url: "/schedule-submissions-management/schedule-submissions",
        type: "item",
      },
      {
        title: "ตรวจสอบและรับรองตารางสอน",
        icon: "",
        url: "/schedule-submissions-management/schedule-submissions-review",
        type: "item",
        role: SUBJECT_SCHEDULE_REVIEW_ROLE_IDS,
      },
      {
        title: "ตรวจสอบคำขอแก้ไขหลังการรับรอง",
        icon: "",
        url: "/schedule-submissions-management/schedule-correction-requests-review",
        type: "item",
        role: SCHEDULE_CORRECTION_REQUEST_REVIEW_ROLE_IDS,
      },
    ],
  },
  
  {
    title: "MENU.TEACH_COMPENSATION",
    url: "/teach-compensation-management",
    icon: "calendar",
    type: "accordion",
    role: TEACH_COMPENSATION_MANAGEMENT_ROLE_IDS,
    classes: "settings-menu-group",
    children: [
      {
        title: "MENU.TEACH_COMPENSATION_REQUEST",
        icon: "",
        url: "/teach-compensation-management/teach-compensation",
        type: "item",
        role: TEACH_COMPENSATION_ROLE_IDS,
      },
      {
        title: "ตรวจสอบและอนุมัติคำขอสอนชดเชย",
        icon: "",
        url: "/teach-compensation-management/teach-compensation-review",
        type: "item",
        role: TEACH_COMPENSATION_REVIEW_ROLE_IDS,
      },
      {
        title: "รายงานคำขอสอนชดเชย",
        icon: "",
        url: "/teach-compensation-management/teach-compensation-report",
        type: "item",
        role: TEACH_COMPENSATION_REPORT_ROLE_IDS,
      },
      {
        title: "สรุปค่าสอนเกินภาระงาน",
        icon: "",
        url: "/teach-compensation-management/compensation-summary",
        type: "item",
        role: COMPENSATION_SUMMARY_MENU_ROLE_IDS,
        featureFlag: "enableCompensationSummary",
      },
      {
        title: "นำเข้าข้อมูลวันลาและไปปฏิบัติงาน",
        icon: "",
        url: "/teach-compensation-management/erp-leave-import",
        type: "item",
        role: ERP_LEAVE_IMPORT_ROLE_IDS,
        featureFlag: "enableErpLeaveImport",
      },
    ],
  },
  {
    title: "การจัดการบันทึกข้อความ",
    url: "/teach-compensation-management/overload-memo-review",
    icon: "document",
    type: "accordion",
    role: OVERLOAD_MEMO_ROLE_IDS,
    featureFlag: "enableOverloadMemo",
    classes: "settings-menu-group",
    children: [
      {
        // ADMIN issues Doc 1 here — moved out of การตั้งค่า so the memo's editor
        // and its review station sit in the same group.
        title: "บันทึกขออนุมัติตารางสอน",
        icon: "",
        url: "/teach-compensation-management/overload-memo",
        type: "item",
        role: OVERLOAD_MEMO_ADMIN_ROLE_IDS,
      },
      {
        title: "ตรวจสอบบันทึกขออนุมัติตารางสอน",
        icon: "",
        url: "/teach-compensation-management/overload-memo-review",
        type: "item",
        role: OVERLOAD_MEMO_REVIEW_ROLE_IDS,
      },
    ],
  },
  {
    // การจัดการเอกสารส่งเบิก — v1.2 UAM r21/r22 wording, prefixed with "การ" on
    // 2026-08-26 tester feedback so it reads like its sibling groups
    // (การจัดการตารางสอน / การจัดการบันทึกข้อความ).
    title: "การจัดการเอกสารส่งเบิก",
    url: "/disbursement-management/registry",
    icon: "dollar",
    type: "accordion",
    role: DISBURSEMENT_MANAGEMENT_ROLE_IDS,
    featureFlag: "enableDisbursement",
    classes: "settings-menu-group",
    children: [
      {
        // r21 — merged display page for all six VE roles.
        title: "ข้อมูลเอกสารส่งเบิก",
        icon: "",
        url: "/disbursement-management/registry",
        type: "item",
        role: DISBURSEMENT_DOCUMENT_VIEW_ROLE_IDS,
      },
      {
        // r22 — v2.0: phase-1 per-cert queue (อาจารย์/การเงิน) + the phase-2 round
        // queue (การเงิน/หัวหน้าสาขา/รองบริหาร). SIT sprint 2 splits the ENTRY, not the
        // route: อาจารย์/หัวหน้าสาขา รับรอง, role อื่น ๆ อนุมัติ. Same pattern as the two
        // /settings/subject entries — disjoint role arrays over one url, so exactly one
        // of the pair ever renders per role.
        title: "ตรวจสอบและรับรองเอกสารส่งเบิก",
        icon: "",
        url: "/disbursement-management/disbursement-certification",
        type: "item",
        role: DISBURSEMENT_CERTIFY_TITLE_ROLE_IDS,
      },
      {
        title: "ตรวจสอบและอนุมัติเอกสารส่งเบิก",
        icon: "",
        url: "/disbursement-management/disbursement-certification",
        type: "item",
        role: DISBURSEMENT_APPROVE_TITLE_ROLE_IDS,
      },
      {
        // v1.3 ADR-3/11 — pre-flow ใบปะหน้า issuance by the dept สารบรรณ — context/decisions/DECISION_DisbursementV13.md
        title: "การจัดการบันทึกข้อความเบิกจ่ายค่าตอบแทนการสอน",
        icon: "",
        url: "/disbursement-management/cover-memos",
        type: "item",
        // แอดมินเห็นเมนูนี้ด้วย แต่เข้าไปแล้วอ่านอย่างเดียว (2026-09-04)
        role: DISBURSEMENT_COVER_MEMO_VIEW_ROLE_IDS,
      },
    ],
  },

  {
    title: "คู่มือการใช้งาน",
    url: "https://www.youtube.com/playlist?list=PLLOBecxB4zwc",
    icon: "book",
    type: "item",
    externalUrl: true,
    openInNewTab: true,
  },
];
